var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"font-weight-bold"},[_vm._v("Dangerous goods")]),_vm._v(" "),_c('Table',{attrs:{"columns":_vm.tableColumns,"data":_vm.tableData}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports